import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    name: '/',
    component: () => import('./view'),
    meta: {
      title: 'message.logo'
    }
  },
  {
    name: 'auth',
    component: () => import('./view/auth'),
    meta: {
      title: 'Auth'
    }
  },
  {
    name: 'stock',
    component: () => import('./view/stock'),
    meta: {
      title: 'message.menu.stock'
    }
  },
  {
    name: 'yearStock',
    component: () => import('./view/yearStock'),
    meta: {
      title: 'message.menu.yearStock'
    }
  },
  {
    name: 'myStock',
    component: () => import('./view/myStock'),
    meta: {
      title: 'message.menu.myStock'
    }
  },
  {
    name: 'mine',
    component: () => import('./view/list/index'),
    meta: {
      title: 'message.menu.mine'
    }
  },  
  {
    name: 'stocked',
    component: () => import('./view/list/index'),
    meta: {
      title: 'message.menu.stocked'
    }
  },
  {
    name: 'held',
    component: () => import('./view/held'),
    meta: {
      title: '资产管理'
    }
  },
  {
    name: 'hrefPage',
    component: () => import('./view/hrefPage/hrefPage.vue'),
    meta: {
      title: '达能资产签收'
    }
  },
  {
    name: 'itemDetail',
    component: () => import('./view/hrefPage/itemDetail.vue'),
    meta: {
      title: '错误信息提交'
    }
  },
  {
    name: 'service',
    component: () => import('./view/service'),
    meta: {
      title: '企业微信接入'
    }
  },
  {
    name: 'service/help',
    component: () => import('./view/service/help'),
    meta: {
      title: '企业微信接入-帮助'
    }
  },
  {
    name: 'ipadStock',
    component: () => import('./view/ipadStock'),
    meta: {
      title: 'IPAD日常资产盘点'
    }
  },
  {
    name: 'myIpadStock',
    component: () => import('./view/myIpadStock'),
    meta: {
      title: '我的IPAD日常资产'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

export {
  router
};
